/*
 * File: d:\projects\AutoFiFront\src\Content\CollapseBox\CollapseEquipment.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday April 25th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 25th 2023 9:47:31 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { Collapse } from 'react-collapse';
import styles from 'Content/CollapseBox/CollapseEquipment/CollapseEquipment.module.css';

type CollapseEquipmentProps = {
    status: boolean,
    itemList: {id: number, Name: string, Optionnal: boolean}[],
    nbItem: number,
    isBlury: boolean
};

function CollapseEquipment(props: CollapseEquipmentProps) {
    return (
        <Collapse isOpened={props.status} initialStyle={{height:"auto"}}>
            <div className={`${styles.listEquipment}`}>
                <ul className={`${styles.columnEquipment} ${props.isBlury ? styles.blury : ""}`}>
                    {
                        props.itemList.map((x: {id: number, Name: string, Optionnal: boolean}, index: number) => { return index < props.nbItem ? <li className={styles.equipmentLi} key={x.Name+index}> {x.Name} </li> :null  })
                    }
                </ul>
            </div>
        </Collapse>
    );
};

export default CollapseEquipment;
